'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _VerificationCodeSection = require('./Sections/VerificationCodeSection');var _VerificationCodeSection2 = _interopRequireDefault(_VerificationCodeSection);
var _PhoneNumberSection = require('./Sections/PhoneNumberSection');var _PhoneNumberSection2 = _interopRequireDefault(_PhoneNumberSection);

var _PhoneVerificationFormMyAccount = require('./PhoneVerificationFormMyAccount.scss');var styles = _interopRequireWildcard(_PhoneVerificationFormMyAccount);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var PhoneVerificationFormMyAccount = function PhoneVerificationFormMyAccount(props) {
  var phoneNumberSection =
  _react2.default.createElement(_PhoneNumberSection2.default, {
    translate: props.translate,
    locale: props.locale,
    onChange: props.onChange,
    validatePhoneNumber: props.validatePhoneNumber,
    sendPhoneNumber: props.sendPhoneNumber,
    fetchReCaptchaToken: props.fetchReCaptchaToken,
    phoneNumberIsInvalid: props.phoneNumberIsInvalid,
    phoneNumberSent: props.phoneNumberSent,
    showPhonePreloader: props.showPhonePreloader,
    isMobile: props.isMobile,
    errorMessage: props.errorMessage,
    showErrorMessage: props.showErrorMessage,
    doResetCaptcha: props.doResetCaptcha,
    phoneNumberAlreadyTaken: props.phoneNumberAlreadyTaken,
    isRtl: props.isRtl,
    tooltipMsg: props.tooltipMsg,
    initialPhoneValue: props.initialPhoneValue,
    phoneIsVerified: props.phoneIsVerified,
    onPhoneChange: props.onPhoneChange });



  var codeSection = props.phoneNumberSent && !props.phoneIsVerified &&
  _react2.default.createElement(_VerificationCodeSection2.default, {
    translate: props.translate,
    onChange: props.onChange,
    validateCode: props.validateCode,
    codeIsValid: props.codeIsValid,
    showCodePreloader: props.showCodePreloader,
    codeIsVerified: props.codeIsVerified,
    isRtl: props.isRtl });



  return (
    _react2.default.createElement('div', { className: styles.verificationForm },
      _react2.default.createElement('div', { className: styles.content },
        _react2.default.createElement('span', { className: styles.label },
          props.translate('phoneNumber')),

        _react2.default.createElement('div', null,
          phoneNumberSection,
          _react2.default.createElement(_reactAddonsCssTransitionGroup2.default, {
              transitionName: 'code-section',
              transitionEnterTimeout: 500,
              transitionLeaveTimeout: 400 },

            codeSection)))));





}; // Styles
// Components
PhoneVerificationFormMyAccount.propTypes = {
  translate: _propTypes2.default.func,
  tooltipMsg: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onPhoneChange: _propTypes2.default.func,
  validateCode: _propTypes2.default.func,
  validatePhoneNumber: _propTypes2.default.func,
  sendPhoneNumber: _propTypes2.default.func,
  fetchReCaptchaToken: _propTypes2.default.func,
  phoneNumberSent: _propTypes2.default.bool,
  codeIsValid: _propTypes2.default.bool,
  codeIsVerified: _propTypes2.default.bool,
  phoneNumberIsInvalid: _propTypes2.default.bool,
  showCodePreloader: _propTypes2.default.bool,
  showPhonePreloader: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  showErrorMessage: _propTypes2.default.bool,
  doResetCaptcha: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  phoneNumberAlreadyTaken: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  phoneIsVerified: _propTypes2.default.bool,
  initialPhoneValue: _propTypes2.default.string };exports.default =


PhoneVerificationFormMyAccount;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerificationMyAccount/PhoneVerificationFormMyAccount.js
// module id = 2796
// module chunks = 0